export { useSwitch } from "./useSwitch.web";
